import { useAppContext } from 'Context/AppContext';
import { CreateBillError, CreateNewBill, CreateHealthInsuranceBill } from './Tabs';

export const CreateBill = () => {
  const { tabNumber } = useAppContext();

  if (tabNumber === 0) return <CreateNewBill />;
  if (tabNumber === 1) return <CreateHealthInsuranceBill />;
  if (tabNumber === 2) return <CreateBillError />;

  return <></>;
};
